import React from 'react';
import MyGallery from "../Gallery/MyGallery";
import './ServicesPage.css';
import {useTranslation} from "react-i18next";

function AluminumFramesPage() {
    const { t } = useTranslation();
    const directory= "/images/alouminia/";
    const filenames=[
        'VPR02521_Vasso_Paraschi.webp',
        'VPR02523_Vasso_Paraschi.webp',
        'VPR02822_Vasso_Paraschi.webp',
        'VPR03226_Vasso_Paraschi.webp',
        'VPR03547_Vasso_Paraschi.webp'
    ];

    return (
        <div className="services-page">
            <h1>{t("Aluminum Frames")}</h1>
            <div className="services-info-container">
                <MyGallery directory={directory} filenames={filenames} />
            </div>

        </div>
    );
}

export default AluminumFramesPage;
